import { copyObj, useAppDispatch, useAppSelector } from '@monorepo/shared';
import {
  findRedirectAccount,
  selectAccounts,
  updateCurrentAccount
} from '@monorepo/shared/store/accountSlice';
import { selectPermission } from '@monorepo/shared/store/authSlice';
import {
  findRedirectNode,
  selectAccountOu,
  selectOU,
  selectOUStatus,
  updateSelected
} from '@monorepo/shared/store/fcOuSlice';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate, useOutletContext } from 'react-router-dom';
import { Loader } from 'rsuite';

export const RedirectAccount = () => {
  const navigate = useNavigate();
  const { redirect_obj } = useOutletContext<{
    redirect_obj: Record<string, any>;
  }>();
  const [isLoading, setIsLoading] = useState<boolean>(
    !!redirect_obj?.account_id
  );
  const ouStatus = useAppSelector(selectOUStatus);
  const ouData = useAppSelector(selectOU);
  const accountOu = useAppSelector(selectAccountOu);
  const userPermission = useAppSelector(selectPermission);
  const accounts = useAppSelector(selectAccounts);
  const dispatch = useAppDispatch();

  const initRedirectAccount = () => {
    const redirectAccount = findRedirectAccount({
      accounts,
      redirect_obj: redirect_obj
    });
    if (redirectAccount) {
      const sourceData = ouData?.length ? ouData : accountOu;
      const redirectNode = findRedirectNode(sourceData, redirect_obj);
      redirectNode && dispatch(updateSelected(copyObj(redirectNode)));
      dispatch(updateCurrentAccount(redirectAccount));
      navigate(`/organization/${redirectAccount?.account_id}`);
    } else {
      navigate(`/organization/${accounts?.[0]?.account_id}`);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (isLoading && ouStatus === 'succeeded' && userPermission === 'passed') {
      initRedirectAccount();
    }
    if (userPermission === 'failed') {
      setIsLoading(false);
    }
  }, [userPermission]);

  return isLoading ? (
    <Loader center content="Please wait while redirecting..." />
  ) : (
    <Outlet context={{}} />
  );
};
